import request from '@/utils/request'

export function treeMinor(speId) {
    return request({
        url: `/infos/minors/${speId}/tree`,
        method: 'get'
    })
}

export function listMinor(speId) {
    return request({
        url: `/infos/minors/${speId}`,
        method: 'get'
    })
}